import { config } from '@/config';
import { SHOP_CUSTOM_SHIPPING_METHOD_SEPARATOR } from '@/constants/custom-shop-name';

const useShippingMethodSeparator = () => {
  const shippingMethodSeparator = SHOP_CUSTOM_SHIPPING_METHOD_SEPARATOR[config.shop || ''] ?? ',';
  return shippingMethodSeparator;
};

export default useShippingMethodSeparator;
